import state from './customerListState'
import mutations from './customerListMutations'
import actions from './customerListActions'
import getters from './customerListGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
